import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { ClubsSearchState } from '../models/clubs.models';
import * as selectors from '../selectors/clubs-search.selectors';

@Injectable({ providedIn: 'root' })
export class ClubsSearchFacadeService extends FacadeService {
  constructor(public override store: Store<ClubsSearchState>) {
    super(store);
  }

  // OBSERVABLES
  panelExpanded$ = this.storeSelect(selectors.getPanelExpanded);
  clubName$ = this.storeSelect(selectors.getClubName);
  clubCode$ = this.storeSelect(selectors.getClubCode);
  clubStartDate$ = this.storeSelect(selectors.getStartDate);
  clubStartDateFormat$ = this.storeSelect(selectors.getStartDateFormat);
  clubStartDateValidation$ = this.storeSelect(selectors.getClubStartDateValidation);
  clubEndDate$ = this.storeSelect(selectors.getClubEndDate);
  clubEndDateFormat$ = this.storeSelect(selectors.getClubEndDateFormat);
  clubEndDateValidation$ = this.storeSelect(selectors.getClubEndDateValidation);
  clubEndDateLTStartDate$ = this.storeSelect(selectors.getClubEndDateLTStartDate);
  showInactiveClubs$ = this.storeSelect(selectors.getShowInactiveClubs);
  clubDisableSearch$ = this.storeSelect(selectors.getClubDisableSearch);

  // OBSERVABLE'S VALUES
  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get clubName() {
    return this.storeSnapshot(this.clubName$);
  }

  get clubCode() {
    return this.storeSnapshot(this.clubCode$);
  }

  get clubStartDateFormat() {
    return this.storeSnapshot(this.clubStartDateFormat$);
  }

  get clubEndDateFormat() {
    return this.storeSnapshot(this.clubEndDateFormat$);
  }

  get showInactiveClubs() {
    return this.storeSnapshot(this.showInactiveClubs$);
  }
}
